export const INPUT_TYPES = {
  TEXT: 'text',
  SEARCH: 'search',
  EMAIL: 'email',
  NUMBER: 'number',
  TEL: 'tel',
  URL: 'url',
  PASSWORD: 'password',
  PHONE: 'phone',
  SELECT: 'select',
  MULTI_SELECT: 'multi-select',
  DATE_PICKER: 'date-picker',
  DATE_PICKER_YEAR: 'date-picker-year',
  ID_ENTITY: 'identity',
  PLATE: 'plate'
};